function contentCardHeightCalculation(elem) {
    var maxHeight = 0;
    var brandPatternHeight = elem.find('.content-card__bg-pattern').height();
    console.log('brandPatternHeight', brandPatternHeight);
    $(elem).css('height', 'auto');
    elem.find('.content-card__row').children().each(function() {
        if($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });
    if(maxHeight >= brandPatternHeight) {
        $(elem).height(maxHeight);
        console.log('Element Height If greater than brandPatternHeight', $(elem).height());
    } else {
        $(elem).height(brandPatternHeight - 48); // minus the negative top i.e 3rem for brand pattern in css
        console.log('Element Height', $(elem).height());
    }
}
function contentCardHeight() {
    $('.content-card').each(function() {
        if($(window).width() >= 1440) {
            if($(this).hasClass('bg-pattern')) {
                contentCardHeightCalculation($(this).children('.content-card__container'));
            } else {
                $(this).children('.content-card__container').css('height', 'auto');
            }
        } else {
            $(this).children('.content-card__container').css('height', 'auto');
        }
    });
}

$(function () {
    // contentCardHeight();
});

$(window).on('load', function () {
    contentCardHeight();
});

$(window).on('resize', function () {
    setTimeout(function () {
        contentCardHeight();
    }, 300);
});
